import { migrateBlockDefinition, type BlockDefinition } from '@tsagko/label-contracts'
import addressBlock from './blocks/address-block.json'
import allergenPanel from './blocks/allergen-panel.json'
import dateBlock from './blocks/date-block.json'
import kvRow from './blocks/kv-row.json'
import labelHeader from './blocks/label-header.json'
import priceBlock from './blocks/price-block.json'
import weightBlock from './blocks/weight-block.json'

const RAW_BLOCKS: unknown[] = [
  weightBlock,
  dateBlock,
  priceBlock,
  addressBlock,
  labelHeader,
  kvRow,
  allergenPanel,
]

const BLOCKS: BlockDefinition[] = RAW_BLOCKS.map(raw => migrateBlockDefinition(raw))

export function getPlatformBlocks(): BlockDefinition[] {
  return BLOCKS
}

export function getPlatformBlock(id: string): BlockDefinition | undefined {
  return BLOCKS.find(b => b.id === id)
}
